module.exports = __webpack_public_path__ + "img/skyspace.e7608510.jpg";